/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Default_DesignationInputs */

const fr_vehicle_default_designation = /** @type {(inputs: Vehicle_Default_DesignationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Véhicule`)
};

const en_vehicle_default_designation = /** @type {(inputs: Vehicle_Default_DesignationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle`)
};

/**
* | output |
* | --- |
* | "Vehicle" |
*
* @param {Vehicle_Default_DesignationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_default_designation = /** @type {((inputs?: Vehicle_Default_DesignationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Default_DesignationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_default_designation(inputs)
	return en_vehicle_default_designation(inputs)
});